// extracted by mini-css-extract-plugin
module.exports = {"root":"TypeField_root__1GoTV","option":"TypeField_option__12hHe"};